export default class GetLastReportsRequest {
    public deviceExternalId: string = "";
    public latestOnly: boolean = false;
}